export default "__VITE_ASSET__CyZYyJwx__"